import qs from "qs";
import React, { useState } from "react";
import ModelSelect from "@Components/CarSelect/modelSelect";
import KindSelect from "@Components/CarSelect/kindSelect";
import { useQuery } from "react-query";
import { BottomFillIcon, TopFillIcon } from "@t8891/icon";
import { fetchInquiryExpenses } from "@Services/api";

const OldSelectCar: React.FC<any> = ({ label, kindData, setCar }) => {
  const [name, setName] = useState("");
  const [showKindSelect, toggleSelect] = useState(false);

  const handleKindSelectChange = (key: "index" | "brand" | "kind" | "model", data: any, carData) => {
    if (key === "model") {
      toggleSelect(false);
      setName(carData.selectBrand.name + " " + carData.selectKind.name + " " + data.modelName);
      setCar(data);
    }
  };
  return (
    <div className='relative flex'>
      <section className='relative flex items-center text-16 w-448 whitespace-pre'>
        {label}:
        <div
          className='w-386 font-regular pl-10 rounded-4 border-1 border-dashed border-[#bbb] text-[#333] relative justify-center flex text-center items-center text-18 cursor-pointer flex-1 h-40  bg-[#ffffff50] ml-6'
          onClick={() => {
            toggleSelect(true);
          }}
        >
          {!name ? (
            <>請選擇（非必選)</>
          ) : (
            <div className='px-20 overflow-hidden text-ellipsis whitespace-pre'>{name}</div>
          )}
          <div className='absolute right-4'>
            {showKindSelect ? <TopFillIcon size={22} /> : <BottomFillIcon size={22} />}
          </div>
          <ModelSelect
            setOpen={toggleSelect}
            open={showKindSelect}
            onChange={handleKindSelectChange}
            className='absolute left-0 top-40 z-30'
          />
        </div>
      </section>
    </div>
  );
};

const SelectCar: React.FC<any> = ({ label, kindData, setCar, showKindSelect, toggleSelect }) => {
  const [brand, setBrand] = useState({});
  const handleKindSelectChange = (key: "index" | "brand" | "kind", data: any) => {
    if (key === "brand") {
      setBrand(data);
    }
    if (key === "kind") {
      toggleSelect(false);
      setCar({ ...brand, brandName: brand.name, kindName: data.name, brandId: brand.id, kindId: data.id });
    }
  };
  return (
    <div className='relative flex'>
      <section className='relative flex items-center text-16 w-448'>
        {label}:
        <div
          className='w-396 font-regular pl-10 rounded-4 border-1 border-dashed border-[#bbb] text-[#333] relative justify-center flex text-center items-center text-18 cursor-pointer flex-1 h-40  bg-[#ffffff50] ml-6'
          onClick={() => {
            toggleSelect(true);
          }}
        >
          {!kindData?.brandName ? (
            <>請選擇</>
          ) : (
            <>
              {kindData?.brandName} {kindData?.kindName}
            </>
          )}
          <div className='absolute right-4'>
            {showKindSelect ? <TopFillIcon size={24} /> : <BottomFillIcon size={24} />}
          </div>
          <KindSelect
            setOpen={toggleSelect}
            open={showKindSelect}
            onChange={handleKindSelectChange}
            className='absolute left-0 top-40 z-30'
          />
        </div>
      </section>
    </div>
  );
};

const ExpensesCard = (props: { expenses: any }) => {
  const { agentRedPackageDiscount, autoDiscount, expectedPay, govDiscount, price } = props?.expenses || {};

  const showTextLists = [
    {
      text: "新車",
      name: "原廠價",
      value: price || "?",
      symbol: "+",
    },
    {
      text: "新車",
      name: "稅費",
      value: props?.expenses?.expenses || "?",
      symbol: "-",
    },
    {
      text: "舊車",
      name: "抵扣",
      value: autoDiscount || "?",
      symbol: "-",
    },
    {
      text: "新車",
      name: "輔助",
      value: govDiscount || "?",
      symbol: "-",
    },
    {
      text: "新車",
      name: "優惠禮",
      value: agentRedPackageDiscount || "?",
      symbol: "",
    },
  ];

  return (
    <div
      className='w-[956px] h-120 mx-auto mb-20 mt-20 pt-8'
      style={{ background: "linear-gradient(180deg,#f9f9f9, #fdfdfd)" }}
    >
      <div className='flex flex-col mt-12 w-350 mx-auto'>
        <div className='flex justify-between item-center'>
          <span className='text-20 text-[#333] font-medium mb-10 flex mx-auto'>
            預計花費：<span className='text-[#FF4333]'>{expectedPay || "?萬"}</span>起
          </span>
        </div>

        <div className='flex w-full justify-around'>
          {showTextLists.map((item, index) => {
            return (
              <>
                <div className='flex flex-col items-center' key={index}>
                  <span className='text-12 text-[#999] font-normal mb-4'>{item.text}</span>
                  <span className='text-14 text[#333] mb-8'>{item.name}</span>
                  <span className='text-12 text-[#999] font-normal'>{item.value}</span>
                </div>
                <span className='flex items-center justify-center -mt-4 mx-14'>{item.symbol}</span>
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const TradeInSelect: React.FC<any> = ({ oldMyid, setOldMyid, kindData, setCar, showKindSelect, toggleSelect }) => {
  const initData = {};
  const { data = initData, refetch } = useQuery<any>(
    [`fetchInquiryExpenses`, kindData?.kindId, oldMyid],
    async () => {
      const res = await fetchInquiryExpenses({ kindId: kindData.kindId, oldMyid: oldMyid });
      if (res?.status === 12000) {
        return res.data;
      }
      return initData;
    },
    {
      enabled: !!kindData?.kindId,
    },
  );

  return (
    <div id={"TradeInSelect"} className='mt-30'>
      <div className='flex justify-between w-[956px] mx-auto'>
        <SelectCar
          showKindSelect={showKindSelect}
          toggleSelect={toggleSelect}
          label={"換新車款"}
          kindData={kindData}
          setCar={(data) => {
            setCar({ k: data.kindId, b: data.brandId });
          }}
        />
        <OldSelectCar
          label={"我的舊車"}
          kindData={oldMyid}
          setCar={(data) => {
            setOldMyid(data.myid);
            refetch();
          }}
        />
      </div>
      <ExpensesCard expenses={data} />
    </div>
  );
};

export default TradeInSelect;
